import { render } from "./LyricsStrikeTheGround.vue?vue&type=template&id=6000205c&scoped=true"
import script from "./LyricsStrikeTheGround.vue?vue&type=script&lang=js"
export * from "./LyricsStrikeTheGround.vue?vue&type=script&lang=js"

import "./LyricsStrikeTheGround.vue?vue&type=style&index=0&id=6000205c&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6000205c"]])

export default __exports__